export var spacing = function spacing() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return function (_ref) {
    var theme = _ref.theme;

    if (theme) {
      if (theme.armor) {
        return theme.armor.spacing(value);
      }

      return theme.spacing(value);
    }

    return value;
  };
};